import { luxonDTValiType } from "@dmca/utils/luxon";
import {
  enum_,
  nullable,
  number,
  object,
  omit,
  pipe,
  string,
  transform,
  type InferOutput,
  array,
} from "valibot";

export enum PulseMeterResourceTypeEnum {
  ELECTRICITY = "electricity",
  WATER = "water",
  GAS = "gas",
}

export const IPulseMeterDBModel = object({
  id: string(),
  device: string(),
  channel: nullable(string()),
  name: string(),
  resourceType: enum_(PulseMeterResourceTypeEnum),
  fixedValue: number(),
  valueMeasurementType: string(),
  timeMeasurementType: string(),
  baselineStartMinute: number(),
  baselineEndMinute: number(),
  baselineSamples: array(object({ day: string(), value: nullable(number()) })),
  createdAt: luxonDTValiType(),
  updatedAt: luxonDTValiType(),
  createdBy: string(),
  updatedBy: string(),
});
export type IPulseMeterDBModel = InferOutput<typeof IPulseMeterDBModel>;

export const IPulseMeterDataDBModel = object({
  id: string(),
  pulseMeterId: string(),
  createdAt: luxonDTValiType(),
  createdBy: string(),
});
export type IPulseMeterDataDBModel = InferOutput<typeof IPulseMeterDataDBModel>;

export const IPulseMeter = object({
  id: string(),
  iotDeviceId: string(),
  channel: nullable(string()),
  name: string(),
  resourceType: enum_(PulseMeterResourceTypeEnum),
  fixedValue: number(),
  valueMeasurementType: string(),
  timeMeasurementType: string(),
});
export type IPulseMeter = InferOutput<typeof IPulseMeter>;

export const IPulseMeterCurrentUsage = object({
  immediateValue: nullable(number()),
  totalValue: number(),
});
export type IPulseMeterCurrentUsage = InferOutput<
  typeof IPulseMeterCurrentUsage
>;

export const PulseMeterInstantGraphData = array(
  object({
    time: luxonDTValiType(),
    intervalStart: luxonDTValiType(),
    value: number(),
  })
);
export type PulseMeterInstantGraphData = InferOutput<
  typeof PulseMeterInstantGraphData
>;

export const IPulseMeterDBToOutputTransform = pipe(
  omit(IPulseMeterDBModel, [
    "baselineStartMinute",
    "baselineEndMinute",
    "baselineSamples",
  ]),
  transform(({ device, ...rest }) => ({
    ...rest,
    iotDeviceId: device,
  }))
);
